import ObjectID from 'bson-objectid';
import { Option } from 'react-dropdown';
import {
	GrowthPigDepartureEventDto,
	GrowthPigEntranceEventDto,
	GrowthPigsEvent,
	IGrowthPigDepartureEventDto,
	IPen,
} from 'shared/api/api';
import { getCorrectProductionTypeBySectionId } from 'shared/helpers/growth-pigs-helper/growth-pig-event-function-helper';
import { GrowthPigDepartureEventBundleListRow } from 'shared/helpers/growth-pigs-helper/growth-pig-event-list-helper';

export const initEditGpeSoldSlaughterData = (
	options: Option[],
	growthPigEvents: GrowthPigsEvent[],
	bundle: GrowthPigDepartureEventBundleListRow,
	hashmapLocations: {
		[key: string]: any;
	},
	siteId?: string,
) => {
	let bundled = growthPigEvents.filter(e => e.bundleIdentifier === bundle.bundleId);
	let initData = [] as GrowthPigDepartureEventDto[];

	// Because of a misunderstanding, we get correct production by sectionId
	const correctProduction = getCorrectProductionTypeBySectionId(bundle.fromSectionId);

	// Setup gpes to edit, with correct values, by pen Options - Empty pens will show aswell
	options.forEach(o => {
		let gpeToUse = bundled.find(gpe => gpe.fromPenId === o.value);
		if (!gpeToUse) {
			let pen = hashmapLocations[o.value] as IPen;
			initData.push(
				GrowthPigDepartureEventDto.fromJS({
					name: o.label,
					siteId: siteId,
					fromBuildingId: pen.buildingId,
					fromSectionId: pen.sectionId,
					correctFromProductionType: correctProduction,
					fromProductionType: bundle.productionType!,
					date: bundle.date!,
					fromPenId: pen.id,
					amount: 0,
					avgWeight: bundle.avgWeight,
					totalWeight: 0,
					bundleIdentifier: bundle.bundleId,
					departureType: bundle.departuredType,
				} as IGrowthPigDepartureEventDto),
			);
		} else {
			let pen = hashmapLocations[o.value] as IPen;
			initData.push(
				GrowthPigDepartureEventDto.fromJS({
					id: gpeToUse.id,
					name: o.label,
					siteId: siteId,
					fromBuildingId: pen.buildingId,
					fromSectionId: pen.sectionId,
					correctFromProductionType: correctProduction,
					fromProductionType: bundle.productionType!,
					date: bundle.date!,
					fromPenId: pen.id,
					amount: gpeToUse.amount,
					avgWeight: bundle.avgWeight,
					totalWeight: gpeToUse.totalWeight,
					bundleIdentifier: bundle.bundleId,
					departureType: bundle.departuredType,
				} as IGrowthPigDepartureEventDto),
			);
		}
	});
	return initData;
};

export const HandlePenChangeSoldSlaughterGpeEdit = (
	data: GrowthPigDepartureEventDto[],
	pensToUse: Option[],
	bundle: GrowthPigDepartureEventBundleListRow,
) => {
	let tmpTotal = bundle.pcs ? bundle.pcs : 0;
	const copyData = [...data];

	// Skip handles pens which need to be unset - This is to handle correct distribution
	let skipped = 0;
	copyData.forEach((e, index) => {
		const row = pensToUse.find(penOption => penOption.value === e.fromPenId);
		if (row) {
			let penCount = Math.ceil(tmpTotal / (pensToUse.length - index + skipped));

			copyData[index] = { ...e, amount: penCount } as GrowthPigDepartureEventDto;
			tmpTotal -= penCount;
		} else {
			copyData[index] = { ...e, amount: 0 } as GrowthPigDepartureEventDto;
			skipped++;
		}
	});

	return copyData;
};

export const handleSoldSlaughterEditBeforeSave = (
	dataToChange: GrowthPigDepartureEventDto[],
	pensToUse: string[],
	bundle: GrowthPigDepartureEventBundleListRow,
	date?: Date,
) => {
	let dataToSave = [] as GrowthPigDepartureEventDto[];
	dataToChange.forEach((e, index) => {
		// Overwrite gpe if is exists, otherwise create a new gpe
		const exists = pensToUse.find(penOption => penOption === e.fromPenId);
		if (exists) {
			let dataItem = { ...e, date: date ? date : e.date } as GrowthPigDepartureEventDto;
			dataItem.totalWeight = dataItem.amount ? dataItem.amount * bundle.avgWeight : 0;
			dataItem.id = dataItem.id ? dataItem.id : new ObjectID().toHexString();
			dataToSave.push(dataItem);
		} else {
			if (!e.amount && e.id) {
				let dataItem = { ...e } as GrowthPigDepartureEventDto;
				dataItem.totalWeight = 0;
				dataToSave.push(dataItem);
			}
		}
	});
	return dataToSave;
};
